import { render, staticRenderFns } from "./weekForOne.vue?vue&type=template&id=f9da096e&scoped=true&"
import script from "./weekForOne.vue?vue&type=script&lang=js&"
export * from "./weekForOne.vue?vue&type=script&lang=js&"
import style0 from "./weekForOne.vue?vue&type=style&index=0&id=f9da096e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9da096e",
  null
  
)

export default component.exports